module.exports = __webpack_public_path__ + "media/images/icons/SVG/040-2c9ef7a69f2dbe29ef6650a6b80c3bad.svg";